import { onUnmounted, readonly, ref, watch } from 'vue'
import type { Ref } from 'vue'

export const PRIORITY_SLA_TICK_MS = 1_000

/**
 * Relógio da tela em "hora do servidor" (spec §8.2, Q18). O desvio
 * `serverNow − Date.now()` é medido quando a resposta chega e aplicado a cada
 * tique: um navegador com o relógio errado não pode fazer um plantão parecer
 * no prazo quando o servidor já o conta como estourado.
 *
 * Um tique só para a tela inteira: cada chip/countdown recebe `nowMs` por prop
 * em vez de abrir o próprio `setInterval`.
 */
export function usePrioritySlaTick(serverNow: () => string | null): {
  nowMs: Readonly<Ref<number | null>>
} {
  const nowMs = ref<number | null>(null)
  let offsetMs: number | null = null

  const update = (): void => {
    nowMs.value = offsetMs === null ? null : Date.now() + offsetMs
  }

  watch(
    serverNow,
    (value) => {
      const parsed = value ? Date.parse(value) : Number.NaN
      offsetMs = Number.isFinite(parsed) ? parsed - Date.now() : null
      update()
    },
    { immediate: true }
  )

  const timer = setInterval(update, PRIORITY_SLA_TICK_MS)
  onUnmounted(() => clearInterval(timer))

  return { nowMs: readonly(nowMs) }
}
